import Joyride, { Step, CallBackProps, STATUS } from 'react-joyride'
import { useSuperAdminStore } from '@/store/superAdminStore'
import { TourContent, DEFAULT_TOUR_PROPS } from './tourDesign'
import { useTranslation } from 'react-i18next'

export const DataStorageSuperAdminTour = () => {
  const {
    adminTour,
    nextAdminStep,
    completeAdminTour,
    setAdminStep,
  } = useSuperAdminStore()
  const { t } = useTranslation('tour')

  // Define tour steps
  const TOUR_STEPS: Step[] = [
    {
      target: 'body',
      content: (
        <TourContent
          title={t('superadmin.dataStorageSuperAdminTour.steps.welcome.title')}
          content={t('superadmin.dataStorageSuperAdminTour.steps.welcome.content')}
        />
      ),
      disableBeacon: true,
      placement: 'center',
      spotlightPadding: 20,
      spotlightClicks: false,
    },
    {
      target: '[data-tour="add-admin-button"]',
      content: (
        <TourContent
          title={t('superadmin.dataStorageSuperAdminTour.steps.addAdminButton.title')}
          content={t('superadmin.dataStorageSuperAdminTour.steps.addAdminButton.content')}
        />
      ),
      disableBeacon: true,
      placement: 'left',
      spotlightPadding: 20,
      spotlightClicks: false,
    },
    {
      target: '[data-tour="search-section"]',
      content: (
        <TourContent
          title={t('superadmin.dataStorageSuperAdminTour.steps.searchFilter.title')}
          content={t('superadmin.dataStorageSuperAdminTour.steps.searchFilter.content')}
        />
      ),
      disableBeacon: true,
      placement: 'bottom',
      spotlightPadding: 20,
      spotlightClicks: false,
    },
    {
      target: '[data-tour="admin-info"]',
      content: (
        <TourContent
          title={t('superadmin.dataStorageSuperAdminTour.steps.adminInfo.title')}
          content={t('superadmin.dataStorageSuperAdminTour.steps.adminInfo.content')}
        />
      ),
      disableBeacon: true,
      placement: 'right',
      spotlightPadding: 20,
      spotlightClicks: false,
    },
    {
      target: '[data-tour="admin-cin"]',
      content: (
        <TourContent
          title={t('superadmin.dataStorageSuperAdminTour.steps.adminCin.title')}
          content={t('superadmin.dataStorageSuperAdminTour.steps.adminCin.content')}
        />
      ),
      disableBeacon: true,
      placement: 'left',
      spotlightPadding: 20,
      spotlightClicks: false,
    },
    {
      target: '[data-tour="admin-status"]',
      content: (
        <TourContent
          title={t('superadmin.dataStorageSuperAdminTour.steps.adminStatus.title')}
          content={t('superadmin.dataStorageSuperAdminTour.steps.adminStatus.content')}
        />
      ),
      disableBeacon: true,
      placement: 'left',
      spotlightPadding: 20,
      spotlightClicks: false,
    },
    {
      target: '[data-tour="admin-actions"]',
      content: (
        <TourContent
          title={t('superadmin.dataStorageSuperAdminTour.steps.adminActions.title')}
          content={t('superadmin.dataStorageSuperAdminTour.steps.adminActions.content')}
        />
      ),
      disableBeacon: true,
      placement: 'left',
      spotlightPadding: 20,
      spotlightClicks: false,
    }
  ]

  // Handle tour callbacks
  const handleJoyrideCallback = (data: CallBackProps) => {
    const { action, index, status, type } = data

    if (type === 'step:after' && action === 'next') {
      nextAdminStep()
    }

    if (status === STATUS.FINISHED || status === STATUS.SKIPPED) {
      completeAdminTour()
    }

    if (type === 'step:before') {
      setAdminStep(index)
    }
  }

  return (
    <>
    <Joyride
      steps={TOUR_STEPS}
      run={adminTour.isActive}
      stepIndex={adminTour.currentStep}
      disableScrollParentFix={true}
      callback={handleJoyrideCallback}
      {...DEFAULT_TOUR_PROPS}
      
    />
    {/* Dark overlay for consistent darkening */}
    {adminTour.isActive && adminTour.currentStep === 0 && (
      <div 
        className="fixed inset-0 bg-black/70 z-[9999] pointer-events-none"
        style={{ transition: 'opacity 0.2s ease' }}
      />
    )}
    </>
  )
} 